import { render, staticRenderFns } from "./MarketplaceOrders.vue?vue&type=template&id=2dd43a3d&"
import script from "./MarketplaceOrders.vue?vue&type=script&lang=js&"
export * from "./MarketplaceOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports